export class StorageUtils {
    static loadFromSessionStorage(key: any) {
        try {
            const serializedState = sessionStorage.getItem(key);
            if (serializedState !== null) {
                return JSON.parse(serializedState);
            }
        } catch (err) {
            console.error(err);
        }

        return null;
    }

    static loadFromLocalStorage(key: any) {
        try {
            const serializedState = localStorage.getItem(key);
            if (serializedState !== null) {
                return JSON.parse(serializedState);
            }
        } catch (err) {
            //console.error(err);
        }

        return null;
    }

    static saveToSessionStorage(key: any, data: any) {
        try {
            sessionStorage.setItem(key, JSON.stringify(data));
            return true;
        } catch (e) {
            //console.error(e);
        }

        return false;
    }

    static saveToLocalStorage(key: any, data: any) {
        try {
            localStorage.setItem(key, JSON.stringify(data));
            return true;
        } catch (e) {
            //console.error(e);
        }

        return false;
    }

    removeFromSessionStorage(key: any) {
        try {
            sessionStorage.removeItem(key);
            return true;
        } catch (e) {}

        return false;
    }

    removeFromLocalStorage(key: any) {
        try {
            localStorage.removeItem(key);
            return true;
        } catch (e) {}

        return false;
    }
}

export class Vector {
    x = 0;
    y = 0;
    z = 0;
    constructor(x: number, y: number, z: number) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    getX() {
        return this.x;
    }
    getY() {
        return this.y;
    }
    getZ() {
        return this.z;
    }

    add(v: any) {
        return new Vector(this.getX() + v.getX(), this.getY() + v.getY(), this.getZ() + v.getZ());
    }

    subtract(v: any) {
        return new Vector(this.getX() - v.getX(), this.getY() - v.getY(), this.getZ() - v.getZ());
    }

    multiply(scalar: any) {
        return new Vector(this.getX() * scalar, this.getY() * scalar, this.getZ() * scalar);
    }

    divide(scalar: any) {
        return new Vector(this.getX() / scalar, this.getY() / scalar, this.getZ() / scalar);
    }

    magnitude() {
        return Math.sqrt(this.getX() * this.getX() + this.getY() * this.getY() + this.getZ() * this.getZ());
    }

    normalize() {
        var magnitude = this.magnitude();
        var vec = new Vector(this.getX(), this.getY(), this.getZ());
        return vec.divide(magnitude);
    }

    toArray() {
        return [this.x, this.y, this.z];
    }
}

export function numberWithCommas(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function isValidDate(d: Date) {
    if (Object.prototype.toString.call(d) !== "[object Date]") return false;
    return !isNaN(d.getTime());
}


export function validateEmail(email : string) {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export function changeTimezone(date: any, ianatz: any) {
    // suppose the date is 12:00 UTC
    var invdate = new Date(
        date.toLocaleString("en-US", {
            timeZone: ianatz,
        })
    );

    // then invdate will be 07:00 in Toronto
    // and the diff is 5 hours
    var diff = date.getTime() - invdate.getTime();

    // so 12:00 in Toronto is 17:00 UTC
    return new Date(date.getTime() - diff); // needs to substract
}

export function msToTime(s: number) {
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    let secsStr = secs + "";
    if (secsStr.length < 2) secsStr = "0" + secsStr;
    let minsStr = mins + "";
    if (minsStr.length < 2) minsStr = "0" + mins;
    return hrs + ":" + minsStr + ":" + secsStr;
}

export function HumanToEpoch(strDate: string) {
    strDate = strDate.replace(/-/g, "/");
    let date = new Date(strDate);
    date = changeTimezone(date, "Europe/London");
    var ok = 0;
    if (!ok) {
        date = new Date(strDate);
        if (date.getFullYear() > 1900) {
            ok = 1;
        }
    }
    var resulttext = date.getTime() + "";
    return resulttext;
}

export function formatDate(date: any) {
    if (date) {
        var d = new Date(parseInt(date.toString())),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }
    return "";
}

export function formatDateWithTime(date: any) {
    if (date) {
        var k = date;
        if (!isNaN(date)) {
            k = parseInt(date.toString());
        }
        var d = new Date(k),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear(),
            hours = "" + d.getHours(),
            minutes = "" + d.getMinutes();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        var ampm = parseInt(hours) >= 12 ? "PM" : "AM";
        if (parseInt(hours) > 12) hours = parseInt(hours) - 12 + "";
        if (parseInt(hours) < 10) hours = "0" + parseInt(hours);
        if (minutes.length < 2) minutes = "0" + minutes;

        return [year, month, day].join("-") + ", " + hours + ":" + minutes + " " + ampm;
    }
    return "";
}

export function formatDateDetailed(date: number, short?: boolean) {
    if (date) {
        var d = new Date(parseInt(date.toString())),
            month = d.getMonth(),
            day = "" + d.getDate(),
            year = d.getFullYear(),
            hours = "" + d.getHours(),
            minutes = "" + d.getMinutes();

        if (day.length < 2) day = "0" + day;
        let monthNames: any = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        if (short) {
            monthNames = monthNames.map((name: string) => name.substring(0, 3));
        }
        var ampm = parseInt(hours) >= 12 ? "PM" : "AM";
        if (parseInt(hours) > 12) hours = parseInt(hours) - 12 + "";
        if (minutes.length < 2) minutes = "0" + minutes;
        var monthName = monthNames[month];
        return [monthName, day, year].join(" ") + " | " + hours + ":" + minutes + " " + ampm;
    }
    return "";
}

export function formatDateShort(date: number) {
    if (date) {
        var d = new Date(parseInt(date.toString())),
            month = d.getMonth(),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (day.length < 2) day = "0" + day;
        let monthNames: any = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];

        monthNames = monthNames.map((name: string) => name.substring(0, 3));
        var monthName = monthNames[month];
        return [day, monthName, year];
    }
    return "";
}

export function formatStringDateDetailed(date: string) {
    const monthNames: any = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    var d: any;
    if (typeof date === "string") {
        d = new Date(Date.parse(date));
    } else {
        return date;
    }
    var month = d.getMonth(),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hours = "" + d.getHours(),
        minutes = "" + d.getMinutes();
    if (day.length < 2) day = "0" + day;
    var ampm = parseInt(hours) >= 12 ? "PM" : "AM";
    if (parseInt(hours) > 12) hours = parseInt(hours) - 12 + "";
    if (minutes.length < 2) minutes = "0" + minutes;
    var monthName = monthNames[month];
    return [monthName, day, year].join(" ") + " | " + hours + ":" + minutes + " " + ampm;
}

export function getCurrentDate(separator = "-") {
    let date = "";
    const d = new Date();
    let month = "" + d.getMonth();
    let day = "" + d.getDate();
    let year = d.getFullYear();
    if (day.length < 2) day = "0" + day;
    if (month.length < 2) month = "0" + month;
    date = year + separator + month + separator + day;
    return date;
}

export function createGuid() {
    function _p8(s: boolean = false) {
        var p = (Math.random().toString(16) + "000000000").substr(2, 8);
        return s ? "" + p.substr(0, 4) + "" + p.substr(4, 4) : p;
    }
    return (_p8() + _p8(true) + _p8(true) + _p8()).toLocaleUpperCase();
}

export function isBase64(str: string) {
    if (str === "" || str.trim() === "") {
        return false;
    }
    try {
        return btoa(atob(str)) === str;
    } catch (err) {
        return false;
    }
}

export const getPosition = (e: any) => {
    var offset = { x: 0, y: 0 };
    while (e) {
        offset.x += e.offsetLeft;
        offset.y += e.offsetTop;
        e = e.offsetParent;
    }

    if (document.documentElement && (document.documentElement.scrollTop || document.documentElement.scrollLeft)) {
        offset.x -= document.documentElement.scrollLeft;
        offset.y -= document.documentElement.scrollTop;
    } else if (document.body && (document.body.scrollTop || document.body.scrollLeft)) {
        offset.x -= document.body.scrollLeft;
        offset.y -= document.body.scrollTop;
    } else if (window.pageXOffset || window.pageYOffset) {
        offset.x -= window.pageXOffset;
        offset.y -= window.pageYOffset;
    }
    return offset;
};

export const disableElement = (element: any) => {
    element.style.opacity = "0.4";
    element.style.cursor = "not-allowed";
    element.style.pointerEvents = "none";
};

export const enableElement = (element: any) => {
    element.style.opacity = "1.0";
    element.style.cursor = "pointer";
    element.style.pointerEvents = "";
};

export const deepCopyObject = (obj: any) => {
    let tempObj: any = {};
    for (let [key, value] of Object.entries(obj)) {
        if (Array.isArray(value)) {
            tempObj[key] = deepCopy(value);
        } else {
            if (typeof value === "object") {
                tempObj[key] = deepCopyObject(value);
            } else {
                tempObj[key] = value;
            }
        }
    }
    return tempObj;
};

export const cleanObject = (obj: any) => {
    Object.keys(obj).forEach((key) => {
        if (obj[key] === undefined) {
            delete obj[key];
        }
    });
    return obj;
};

export const deepCopy = (arr: any) => {
    let copy: any = [];
    arr.forEach((elem: any) => {
        if (Array.isArray(elem)) {
            copy.push(deepCopy(elem));
        } else {
            if (typeof elem === "object") {
                copy.push(deepCopyObject(elem));
            } else {
                copy.push(elem);
            }
        }
    });
    return copy;
};

export const hexToRgb = function (hex: string) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
};

export const rgbToHex = function (r: number, g: number, b: number) {
    function componentToHex(c: number) {
        var hex = c.toString(16).toUpperCase();
        return hex.length === 1 ? "0" + hex : hex;
    }
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
};

export function calculateLogarithm(x: number) {
    // position will be between 0 and 100
    var minp = 0;
    var maxp = 100;

    // The result should be between 100 an 1000
    var minv = Math.log(100);
    var maxv = Math.log(1000);

    // calculate adjustment factor
    var scale = (maxv - minv) / (maxp - minp);

    return Math.exp(minv + scale * (x - minp)) - 100; //so that min value return 0
}

export function logScale(position: number, minp: number, maxp: number) {
    var maxLineLength = maxp - minp;
    return minp + (Math.log(position * maxLineLength + 1) / Math.log(maxLineLength + 1)) * maxLineLength;
}

export const jenksMatrices = function (data: any, n_classes: number) {
    // in the original implementation, these matrices are referred to
    // as `LC` and `OP`
    //
    // * lower_class_limits (LC): optimal lower class limits
    // * variance_combinations (OP): optimal variance combinations for all classes
    var lower_class_limits = [],
        variance_combinations = [],
        // the variance, as computed at each step in the calculation
        variance = 0;

    // Initialize and fill each matrix with zeroes
    for (var i = 0; i < data.length + 1; i++) {
        var tmp1 = [],
            tmp2 = [];
        for (var j = 0; j < n_classes + 1; j++) {
            tmp1.push(0);
            tmp2.push(0);
        }
        lower_class_limits.push(tmp1);
        variance_combinations.push(tmp2);
    }

    for (i = 1; i < n_classes + 1; i++) {
        lower_class_limits[1][i] = 1;
        variance_combinations[1][i] = 0;
        // in the original implementation, 9999999 is used but
        // since Javascript has `Infinity`, we use that.
        for (j = 2; j < data.length + 1; j++) {
            variance_combinations[j][i] = Infinity;
        }
    }

    for (var l = 2; l < data.length + 1; l++) {
        // `SZ` originally. this is the sum of the values seen thus
        // far when calculating variance.
        var sum = 0,
            // `ZSQ` originally. the sum of squares of values seen
            // thus far
            sum_squares = 0,
            // `WT` originally. This is the number of
            w = 0,
            // `IV` originally
            i4 = 0;

        // in several instances, you could say `Math.pow(x, 2)`
        // instead of `x * x`, but this is slower in some browsers
        // introduces an unnecessary concept.
        for (var m = 1; m < l + 1; m++) {
            // `III` originally
            var lower_class_limit = l - m + 1,
                val = data[lower_class_limit - 1];

            // here we're estimating variance for each potential classing
            // of the data, for each potential number of classes. `w`
            // is the number of data points considered so far.
            w++;

            // increase the current sum and sum-of-squares
            sum += val;
            sum_squares += val * val;

            // the variance at this point in the sequence is the difference
            // between the sum of squares and the total x 2, over the number
            // of samples.
            variance = sum_squares - (sum * sum) / w;

            i4 = lower_class_limit - 1;

            if (i4 !== 0) {
                for (j = 2; j < n_classes + 1; j++) {
                    if (variance_combinations[l][j] >= variance + variance_combinations[i4][j - 1]) {
                        lower_class_limits[l][j] = lower_class_limit;
                        variance_combinations[l][j] = variance + variance_combinations[i4][j - 1];
                    }
                }
            }
        }

        lower_class_limits[l][1] = 1;
        variance_combinations[l][1] = variance;
    }

    return {
        lower_class_limits: lower_class_limits,
        variance_combinations: variance_combinations,
    };
};

export function arrayEqualValues(a: any, b: any) {
    return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val) => val === b.find((value) => val === value))
    );
}

export function arrayAddProp(array: any, propName: string, propValue: string) {
    array.forEach((row: any) => {
        row[propName] = propValue;
    });
    return array;
}

export function allArrayChildren(arr: any) {
    var result: any = [];
    const getAllChildren = (array: any) => {
        result = result.concat(Object.values(array));
    };
    arr.forEach((entry: any) => {
        getAllChildren(entry);
    });
    return result;
}

export function uniqueArrayProp(arr: any, prop: string) {
    const arrCopy = deepCopy(arr);
    var dict: any = {};
    arrCopy.forEach((item: any) => {
        const key = item[prop];
        dict[key] = item;
    });
    var result = Object.values(dict);
    return result;
}

export function uniqueArrayPropPriority(arr: any, prop: string, priorityProp: string, priorityValues: any) {
    const arrCopy = deepCopy(arr);
    var dict: any = {};
    arrCopy.forEach((item: any) => {
        const key = item[prop];
        if (dict[key]) {
            if (priorityValues[dict[key][priorityProp]] < priorityValues[item[priorityProp]]) {
                dict[key] = item;
            }
        } else {
            dict[key] = item;
        }
    });
    var result = Object.values(dict);
    return result;
}

export function uniqueArray(arr: any) {
    return arr.filter((item: any, pos: number) => {
        return arr.indexOf(item) === pos;
    });
}

export function unique2ArraysValues(arr1: any, arr2: any, uniqueProp: string) {
    arr2.forEach((value: any) => {
        const matchIndex = arr1.findIndex((row: any) => value[uniqueProp] === row[uniqueProp]);
        if (matchIndex > -1) {
            arr1[matchIndex] = value;
        }
    });
    return arr1;
}

export function reverseArray(arr: any) {
    return arr.reverse();
}

export const cleanArray = (arr: any) => arr.filter((entry: any) => typeof entry !== "undefined" && entry !== "");

export const sortArrayByProp = (arr: any, prop: string, reverse: boolean = false, isInteger?: boolean) =>
    arr.sort((a: any, b: any) => {
        if (!reverse) {
            if (isInteger) {
                if (parseInt(a[prop]) < parseInt(b[prop])) {
                    return -1;
                }
                if (parseInt(a[prop]) > parseInt(b[prop])) {
                    return 1;
                }
            } else {
                let firstval = typeof a[prop] !== "undefined" ? a[prop].toString().trim().toUpperCase() : a[prop] 
                let secondVal = typeof b[prop] !== "undefined" ? b[prop].toString().trim().toUpperCase() : b[prop] 
                if (firstval < secondVal) {
                    return -1;
                }
                if (firstval > secondVal) {
                    return 1;
                }
            }
        } else {
            if (isInteger) {
                if (parseInt(b[prop]) < parseInt(a[prop])) {
                    return -1;
                }
                if (parseInt(b[prop]) > parseInt(a[prop])) {
                    return 1;
                }
            } else {
                let firstval = typeof a[prop] !== "undefined" ? a[prop].toString().trim().toUpperCase() : a[prop] 
                let secondVal = typeof b[prop] !== "undefined" ? b[prop].toString().trim().toUpperCase() : b[prop] 
                if (secondVal < firstval) {
                    return -1;
                }
                if (secondVal > firstval) {
                    return 1;
                }
            }
        }
        return 0;
    });

export const sortArrayByPropValue = (arr: any, prop: string, value: string, reverse: boolean = false) =>
    arr.sort((a: any, b: any) => {
        if (a[prop] === value) {
            return -1;
        } else if (b[prop] === value) {
            return 1;
        }
        return 0;
    });

export const sortArray = (arr: any) => arr.sort((a: number, b: number) => a - b);

export const sumArray = (arr: any) => arr.reduce((a: number, b: number) => a + b, 0);

export const multiplyArray = (arr: any, b: number) => arr.map((a: number) => a * b);

export const intArray = (arr: any) => arr.map((a: number) => parseInt(a + ""));

export const meanArray = (arr: any) => sumArray(arr) / arr.length;

export const substrArray = (arr1: any, arr2: any) => {
    return arr1.concat(arr2).filter((item: any) => !arr1.includes(item) || !arr2.includes(item));
};

/** sample standard deviation */
export const stdArray = (arr: any) => {
    const mu = meanArray(arr);
    const diffArr = arr.map((a: number) => (a - mu) ** 2);
    return Math.sqrt(sumArray(diffArr) / (arr.length - 1));
};

/** return min value */
export const minValueArray = (arr: any) => {
    var curMin = arr[0];
    for (var i = 0; i < arr.length; i++) {
        if (curMin > arr[i]) {
            curMin = arr[i];
        }
    }
    return curMin;
};

/** return max value */
export const maxValueArray = (arr: any) => {
    var curMax = arr[0];
    for (var i = 0; i < arr.length; i++) {
        if (curMax < arr[i]) {
            curMax = arr[i];
        }
    }
    return curMax;
};

export const maxValueArrayProp = (arr: any, prop: string) => {
    return arr.reduce((prev: any, current: any) => {
        return prev[prop] > current[prop] ? prev : current;
    });
};

export const maxArrayProp = (arr: any, prop: string) => {
    var current: any = {};
    arr.forEach((entry: any) => {
        if (entry[prop]) {
            if (current[prop]) {
                if (entry[prop] > current[prop]) {
                    current = { ...entry };
                }
            } else {
                current = { ...entry };
            }
        }
    });
    if (Object.values(current).length > 0) {
        return [current];
    }
    return arr;
};

var getQuantiles = function (nbClass: number, data: any) {
    var newData = [...data];
    var tmp = sortArray(newData);
    var quantiles = [];

    var step = newData.length / nbClass;
    for (var i = 1; i < nbClass; i++) {
        var qidx = Math.round(i * step + 0.49);
        quantiles.push(tmp[qidx - 1]); // zero-based
    }

    return quantiles;
};

export var getClassQuantile = function (nbClass: number, data: any) {
    var tmp = sortArray([...data]);
    var bounds = getQuantiles(nbClass, [...data]);
    bounds.unshift(tmp[0]);

    if (bounds[tmp.length - 1] !== tmp[tmp.length - 1]) {
        bounds.push(tmp[tmp.length - 1]);
    }

    return bounds;
};

export var capitalize = function (str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export var uncapitalize = function (str: string) {
    return str.charAt(0).toLowerCase() + str.slice(1);
};

export var slugToCamelCase = function (str: string, separators: string = "_") {
    if (!separators || typeof separators != "string") {
        separators = "-_.";
    }
    var result = str.replace(new RegExp("[" + separators + "][a-z]", "ig"), function (s) {
        return s.substr(1, 1).toUpperCase();
    });
    return result;
};

export var camelCaseToWords = function (str: string) {
    var result = "";
    for (var i = 0; i < str.length; i++) {
        if (i === 0 && str.charAt(i) === str.charAt(i).toLowerCase()) {
            result += str[i].toUpperCase();
        } else if (str.charAt(i) === str.charAt(i).toUpperCase()) {
            result += " " + str[i];
        } else {
            result += str[i];
        }
    }
    return result;
};

export var round2Decimals = (num: number) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
};

export function parseINIString(data: string) {
    var regex = {
        section: /^\s*\[\s*([^\]]*)\s*\]\s*$/,
        param: /^\s*([^=]+?)\s*=\s*(.*?)\s*$/,
        comment: /^\s*;.*$/,
    };
    if (typeof data !== "string") {
        return;
    }
    var value: any = {};
    var lines = data.split(/[\r\n]+/);
    var section: any = null;
    var match: any = null;
    lines.forEach(function (line: string) {
        if (regex.comment.test(line)) {
            return;
        } else if (regex.param.test(line)) {
            match = line.match(regex.param);
            if (section) {
                value[section][match[1]] = match[2];
            } else {
                value[match[1]] = match[2];
            }
        } else if (regex.section.test(line)) {
            match = line.match(regex.section);
            value[match[1]] = {};
            section = match[1];
        } else if (line.length === 0 && section) {
            section = null;
        }
    });
    return value;
}

export function rgbToArray(rgb: any, alpha?: number) {
    var colorArray: any = [rgb.r / 256.0, rgb.g / 256.0, rgb.b / 256.0];
    if (alpha) {
        colorArray = [...colorArray, alpha];
    }
    return colorArray;
}

export function arrayToRgb(array: any) {
    var rgbArray: any = [];
    array.forEach((entry: any) => {
        rgbArray.push(
            "rgb:(" +
                parseInt(entry[0] * 255 + "") +
                "," +
                parseInt(entry[1] * 255 + "") +
                "," +
                parseInt(entry[2] * 255 + "") +
                ")"
        );
    });
    return rgbArray;
}

// Converts a #ffffff hex string into an [r,g,b] array
export var h2r = function (hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
};

// Inverse of the above
export var r2h = function (rgb: any) {
    return "#" + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
};

export var rgbToHSL = (rgbArray: any) => {
    var result: any = [];
    rgbArray.forEach((rgb: string) => {
        var arr = rgb.replace("rgb(", "").replace(")", "").split(",");
        ///const inv255 = 1.0 / 255;
        arr = multiplyArray(arr, 1);
        arr = intArray(arr);
        result.push(arr);
    });
    return result;
};

export var HSLtoRGB = (hsl: any) => {
    var result: any = [];
    hsl.forEach((value: any) => {
        var arr = "rgb(" + value[0] + "," + value[1] + "," + value[2] + ")";
        result.push(arr);
    });
    return result;
};

export function AlphaToHex(alpha: number) {
    var a: string = Math.round(alpha * 255.0).toString(16);
    if (a.length === 1) a = "0" + a;
    return a;
}

export var findCommonValues = (arr1: any, arr2: any) => {
    return arr1.filter((val: string) => arr2.includes(val));
};

export var findCommonAttributes = (arr1: any, arr2: any, attribute: string) => {
    return arr1.filter((val: any) => (arr2[attribute] = val[attribute]));
};

export const round = (num: number) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const dotProduct = (vector1: any, vector2: any) => {
    var result = 0;
    var len = vector1.length;
    if (vector2.length !== len) {
        return result;
    }
    for (var i = 0; i < len; i++) {
        result += vector1[i] * vector2[i];
    }
    return result;
};

export function radians_to_degrees(radians: any) {
    var pi = Math.PI;
    return radians * (180 / pi);
}

export function downloadFile(url: string, fileName: string) {
    var link: any = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function forceDownload(url: string, fileName: string) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    };
    xhr.send();
}

export const copyContent = async (text: any, callback: any) => {
    try {
        await navigator.clipboard.writeText(text);
        console.log("Content copied to clipboard");
        callback("succcess");
    } catch (err) {
        console.error("Failed to copy: ", err);
        callback("error");
    }
};

export function createCookie(name: string, value: string, days?: number, domain?: string) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + ";expires=" + expires + ";domain=" + domain + ";path=/";
}

export const stringToJSON = (str: string, prefix = "") => {
    const json: any = {};
    var lines = str.split(/\r?\n/);
    if (lines.length > 0) {
        lines.forEach((line: string) => {
            if (line !== "") {
                const index = line.indexOf("=");
                const key = line.substring(0, index);
                const value = line.substring(index + 1, line.length);
                json[prefix + key] = value;
            }
        });
    }
    return json;
};

export const csvtoRows = (csv: string) => {
    const columns: any = [],
        rows: any = [];
    if (csv !== "") {
        var lines = csv.split(/\r?\n/);
        if (lines.length > 0) {
            lines[0].split(",").forEach((fieldName: string) => {
                if (fieldName !== "") {
                    columns.push({ field: fieldName });
                }
            });
            var isValid: boolean = false;
            lines.forEach((line: any, index: number) => {
                if (index > 0) {
                    var obj: any = {};
                    var values = line.split(",");
                    isValid = values.length === columns.length;
                    values.forEach((value: string, colIdx: number) => {
                        if (columns[colIdx] && columns[colIdx]["field"]) {
                            obj[columns[colIdx]["field"]] = value;
                        }
                    });
                    if (isValid) {
                        rows.push(obj);
                    }
                }
            });
        }
    }
    return rows;
};

export const RowsToCsv = (rows: any) => {
    var csv = "";
    const cols: any = [];
    const values: any = [];
    rows.forEach((row: any, index: number) => {
        const line: any = [];
        Object.entries(row).forEach((entry: any) => {
            const id = entry[0];
            var value = entry[1];
            if (id !== "Source") {
                if (index === 0) {
                    cols.push(id);
                }
                if (value === "_table_") {
                    value = "";
                }
                line.push(value);
            }
        });
        values.push(line);
    });
    csv += cols.join(",") + "\n";
    values.forEach((value: any) => {
        csv += value.join(",") + "\n";
    });

    return csv;
};

export function daysFromEpoch(unixTime: number) {
    var epochDate: number = new Date("01-01-1900").getTime() / 1000;
    var res = Math.abs(unixTime - epochDate);
    var difference = Math.floor(res / 86400);
    return difference;
}

export function unixDateFromEpoch(epoch: number) {
    var epochDate: number = new Date("01-01-1900").getTime();
    epochDate += epoch * 86400 * 1000;
    return Math.floor(epochDate);
}

var timeoutIds: any = {};

function timeout(id: string, ms: number) {
    return new Promise((resolve) => (timeoutIds[id] = setTimeout(resolve, ms)));
}

export async function sleep(id: string, fn: any, ms: number, ...args: any) {
    await timeout(id, ms);
    clearTimeout(timeoutIds[id]);
    return fn(...args);
}

export async function sleepX(id: string, fn: any, ms: number) {
    await timeout(id, ms);
    clearTimeout(timeoutIds[id]);
    fn();
}
